"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.QuoteLineItemCurrencyField = void 0;
var useQuoteCurrencyFormatter_1 = require("@CommonFrontendBackend/QuoteWidgets/useQuoteCurrencyFormatter");
var react_1 = __importDefault(require("react"));
var tiny_invariant_1 = __importDefault(require("tiny-invariant"));
var QuoteLineItemCurrencyField = function (_a) {
    var field = _a.field;
    var currencyFormatter = (0, useQuoteCurrencyFormatter_1.useQuoteCurrencyFormatter)();
    (0, tiny_invariant_1.default)(field.strategy === "fixed", "Tiered pricing strategy not implemented yet");
    return react_1.default.createElement("div", null, currencyFormatter.format(field.value));
};
exports.QuoteLineItemCurrencyField = QuoteLineItemCurrencyField;
